import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ProgressTrendsChart from './ProgressTrendsChart';

/**
 * The two side-by-side progress-trend charts (by location and by period).
 */
const DashboardTrendsRow = ({
  progressTrendsByLocationData,
  loadingProgressTrendsByLocation,
  progressTrendsByPeriodsData,
  loadingProgressTrendsByPeriods,
}) => (
  <Row className="mb-4">
    <Col md={6}>
      <div>
        <ProgressTrendsChart
          chartData={progressTrendsByLocationData || { series: [], categories: [] }}
          loading={loadingProgressTrendsByLocation}
          title="Progress Trends by Location"
          icon="📈"
          description="Track progress evolution across locations over time"
          chartType="line"
          emptyStateMessage="Select locations and periods to view progress trends over time."
          enableDataLabels={false}
          useComplexColors={true}
        />
      </div>
    </Col>
    <Col md={6}>
      <div>
        <ProgressTrendsChart
          chartData={progressTrendsByPeriodsData || { series: [], categories: [] }}
          loading={loadingProgressTrendsByPeriods}
          title="Progress Trends by Periods"
          icon="📅"
          description="Analyze progress evolution across time periods"
          chartType="area"
          emptyStateMessage="Select periods to view progress trends over time."
          enableDataLabels={true}
          useComplexColors={false}
        />
      </div>
    </Col>
  </Row>
);

export default DashboardTrendsRow;
